import { type FieldErrors } from 'react-hook-form';
import { errorsToViewableList } from '../form/errors/FormErrorsAlert.tsx';

export function getAllFormItemErrors(errors: FieldErrors | FieldErrors[]) {
  if (Array.isArray(errors)) {
    return errors.flatMap(error => errorsToViewableList(error));
  }
  return errorsToViewableList(errors);
}
